import { TacticsPermissionsConfig } from './tactics-permissions.config';
import { FunnelsPermissionsConfig } from '@core/permissions/configs/funnels-permissions.config';
import { TeamsPermissionsConfig } from '@core/permissions/configs/teams-permissions.config';

export const permissionsConfigs = [TacticsPermissionsConfig, FunnelsPermissionsConfig, TeamsPermissionsConfig];
